'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_PageSeo$Meta(title, description) {
  this.gn = null;
  this.gm = null;
  this.gn = title;
  this.gm = description;
}
export { $c_Lio_intela_sites_digitalinternship_data_PageSeo$Meta as $c_Lio_intela_sites_digitalinternship_data_PageSeo$Meta };
$p = $c_Lio_intela_sites_digitalinternship_data_PageSeo$Meta.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_PageSeo$Meta;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_PageSeo$Meta() {
}
export { $h_Lio_intela_sites_digitalinternship_data_PageSeo$Meta as $h_Lio_intela_sites_digitalinternship_data_PageSeo$Meta };
$h_Lio_intela_sites_digitalinternship_data_PageSeo$Meta.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, (-1612482795), true);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_PageSeo$Meta) && ((this.gn === x$0.gn) && (this.gm === x$0.gm))));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 2;
});
$p.I = (function() {
  return "Meta";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.gn;
  }
  if ((n === 1)) {
    return this.gm;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_PageSeo$Meta(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bv)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_PageSeo$Meta as $isArrayOf_Lio_intela_sites_digitalinternship_data_PageSeo$Meta };
var $d_Lio_intela_sites_digitalinternship_data_PageSeo$Meta = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_PageSeo$Meta, "io.intela.sites.digitalinternship.data.PageSeo$Meta", ({
  bv: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_PageSeo$Meta as $d_Lio_intela_sites_digitalinternship_data_PageSeo$Meta };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Page-Seo$-Meta.js.map
